import React from 'react';
import CollapsibleSection from './CollapsibleSection';
import AdminGroup from './AdminGroup';
import UserRow from './UserRow';
import { CARD } from '../ui';

// One company in the dev view: a collapsible card wrapping that company's admin
// group and everything beneath it. Collapsing a company is the only way a dev
// with a long list of them can work on one at a time.
//
// Dev accounts are listed above the group rather than inside it. A dev has a
// company in the data, but stands outside its hierarchy — filing them under the
// admins would claim a reporting line that doesn't exist.
const CompanySection = ({
  company,
  users,
  passwords = {},
  onDelete,
  canDelete,
  onResetPassword,
  canResetPassword,
  showTempPasswords,
  currentUserId,
  defaultOpen = true,
}) => {
  const devs = users.filter((u) => u.role === 'dev');
  const managed = users.filter((u) => u.role !== 'dev');

  return (
    <CollapsibleSection
      tone="company"
      title={company.name}
      count={users.length}
      countLabel={users.length === 1 ? 'user' : 'users'}
      defaultOpen={defaultOpen}
      className={`${CARD} overflow-hidden`}
    >
      {devs.length > 0 && (
        <CollapsibleSection
          tone="group"
          title="Devs"
          count={devs.length}
          className="border-b border-gray-700"
        >
          <ul className="divide-y divide-gray-700/60">
            {devs.map((dev) => (
              <UserRow
                key={dev.id}
                member={dev}
                password={passwords[dev.id]}
                onDelete={onDelete}
                canDelete={canDelete}
                onResetPassword={onResetPassword}
                canResetPassword={canResetPassword}
                showTempPassword={showTempPasswords}
                currentUserId={currentUserId}
                indent
              />
            ))}
          </ul>
        </CollapsibleSection>
      )}
      <AdminGroup
        users={managed}
        showCompany={false}
        passwords={passwords}
        onDelete={onDelete}
        canDelete={canDelete}
        onResetPassword={onResetPassword}
        canResetPassword={canResetPassword}
        showTempPasswords={showTempPasswords}
        currentUserId={currentUserId}
      />
    </CollapsibleSection>
  );
};

export default CompanySection;
